import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import ReactModal from 'react-modal';

import {
  clearAccessCodeChallenge,
  processAccessCode,
} from 'actions/accessCodes';

import ModalContent from './ModalContent';

class AccessCodeChallengeDialog extends Component {
  state = {
    modalIsOpen: false,
  }

  componentDidMount() {
    const { displayChallenge, loggedIn } = this.props;
    this.setState({ modalIsOpen: displayChallenge && loggedIn });
  }

  componentDidUpdate(prevProps) {
    const { displayChallenge, loggedIn } = this.props;
    if (prevProps.displayChallenge !== displayChallenge || prevProps.loggedIn !== loggedIn) {
      this.setState({ modalIsOpen: displayChallenge && loggedIn });
    }
  }

  handleClick = async () => {
    const { accessCode, dispatch } = this.props;
    await dispatch(processAccessCode(accessCode.name));
    dispatch(clearAccessCodeChallenge());
  }

  render() {
    const { accessCode, isFetching } = this.props;
    const { modalIsOpen } = this.state;

    const {
      image,
      initialMessage: message,
    } = accessCode;

    return (
      <ReactModal
        isOpen={modalIsOpen}
        className={classnames(
          'modal--tooltip-like__content',
          'modal--access-code-challenge',
        )}
        overlayClassName={classnames(
          'modal--tooltip-like__overlay',
          'modal__overlay--has-visible-backdrop',
          'modal__overlay--has-transition',
        )}
      >
        {isFetching ? null : (
          <ModalContent
            image={image}
            message={message}
            onClick={this.handleClick}
          />
        )}
      </ReactModal>
    );
  }
}

AccessCodeChallengeDialog.displayName = 'AccessCodeChallengeDialog';

AccessCodeChallengeDialog.propTypes = {
  accessCode: PropTypes.shape({}).isRequired,
  displayChallenge: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  loggedIn: PropTypes.bool.isRequired,
};

const mapStateToProps = ({
  accessCodes: { accessCode, displayChallenge, isFetching },
  user: { loggedIn },
}) => ({
  accessCode, displayChallenge, isFetching, loggedIn,
});

export default connect(mapStateToProps)(AccessCodeChallengeDialog);